<script setup lang="ts">
import { ref, watch } from 'vue'
import { useCommonStore } from '@/stores/modules/common'
import AdvanceFightDamage from './components/AdvanceFightDamage.vue'
import FightDamage from './components/FightDamage.vue'
import Help from './components/Help.vue'
import HoldGold from './components/HoldGold.vue'
import PeakFightDamage from './components/PeakFightDamage.vue'

const commonStore = useCommonStore()

const curTab = ref('')

watch(
  () => commonStore.path,
  (val) => {
    if (val === 'Rank' && !curTab.value) {
      curTab.value = 'advanceDamage'
    }
  },
)
</script>

<template>
  <div class="rank-page page">
    <h2>奇闻</h2>

    <el-tabs v-model="curTab" stretch>
      <el-tab-pane label="昨日巅峰伤害榜" name="peakDamage" class="pane" lazy>
        <PeakFightDamage class="pane-item" />
      </el-tab-pane>
      <el-tab-pane label="昨日进阶伤害榜" name="advanceDamage" class="pane" lazy>
        <AdvanceFightDamage class="pane-item" />
      </el-tab-pane>
      <el-tab-pane label="昨日伤害榜" name="damage" class="pane" lazy>
        <FightDamage class="pane-item" />
      </el-tab-pane>
      <el-tab-pane label="昨日助力榜" name="help" class="pane" lazy>
        <Help class="pane-item" />
      </el-tab-pane>
      <el-tab-pane label="持有金币榜" name="holdGold" class="pane" lazy>
        <HoldGold class="pane-item" />
      </el-tab-pane>
    </el-tabs>

    <FooterBar />
  </div>
</template>

<style lang="scss" scoped>
.rank-page {
  display: flex;
  flex-flow: column nowrap;
  padding-top: 0;
  .el-tabs {
    flex: 1;
    display: flex;
    flex-flow: column nowrap;
    overflow: hidden;
  }
  :deep() {
    .el-tabs__content {
      flex: 1;
      .pane {
        height: 100%;
        overflow: hidden;
        .pane-item {
          height: 100%;
          overflow: hidden;
          display: flex;
          flex-flow: column nowrap;
        }
      }
    }
  }
}
</style>
